import React, { useEffect, useState } from "react";
import troubleIcon from "../../assests/error.svg";
import setting from "../../assests/Settings.svg";
import downarrow from "../../assests/downarrowdown.svg";
import uparrow from "../../assests/uparrow.svg";
import range from "../../assests/Rectangle.svg";
import emptyrange from "../../assests/emptyrange.svg";
import clock from "../../assests/Clock.svg";
import calendar from "../../assests/calendar.svg";

import { baseurl } from "../Url";
import style from "./Trouble.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";

const Trouble = () => {
  const [data, setData] = useState([]);
  const [expandedModules, setExpandedModules] = useState(new Set());
  const [expandedTopics, setExpandedTopics] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [lastAssessmentData, setLastAssessmentData] = useState(null);
  const [selectedPracticeContext, setSelectedPracticeContext] = useState(null);
  const [returnNavState, setReturnNavState] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const hasActiveSession = Boolean(lastAssessmentData?.session_status);

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    fetchTrouble();
  }, []);

  const fetchTrouble = async () => {
    const USERID = localStorage.getItem("USERID");
    const token = localStorage.getItem("access-token");
    const org_id = localStorage.getItem("ORGID");
    const club_id = localStorage.getItem("ClubID");
    if (!token) return;

    try {
      const response = await fetch(`${baseurl}/practice/weak-students`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user_id: USERID,org_id:org_id,club_id:club_id, }),
      });

      const res = await response.json();
      if (res?.status_code === 200) {
        setData(res.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAiId = async (topicID) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    if (!token) return null;
    try {
      const response = await fetch(`${baseurl}/userlessons_ai/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          topic_id: topicID,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        return data?.data?.[0]?.ai_id ?? null;
      }
    } catch (error) {
      console.error("Error fetching AI ID:", error);
    }
    return null;
  };

  const checkActiveSession = async (ctx) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    if (!token) return null;
    try {
      const response = await fetch(`${baseurl}/practice/active-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          User_ID: userId,
          main_topic_id: ctx.main_topic_id,
          topic_id: ctx.topic_id,
          ai_id: ctx.ai_id,
          mapped_skills: [
            {
              label: ctx.skill_name,
              skill_id: ctx.skill_id,
              skill_name: ctx.skill_name,
              value: ctx.skill_id,
            },
          ],
        }),
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error("Error checking active session:", error);
    }
    return null;
  };

  const getPracticeState = (ctx, continueSession) => {
    const base = {
      ai_id: ctx.ai_id,
      continue: continueSession,
      page_reload: true,
      main_topic_id: ctx.main_topic_id,
      topic_id: ctx.topic_id,
      topic_name: ctx.topic_name,
      subtopic_title: ctx.subtopic_title,
      subtopic_title_md: ctx.subtopic_title,
      skill_id: ctx.skill_id,
      skill_name: ctx.skill_name,
      mapped_skills: [
        {
          label: ctx.skill_name,
          skill_id: ctx.skill_id,
          skill_name: ctx.skill_name,
          value: ctx.skill_id,
        },
      ],
      fromTrouble: true,
    };
    if (returnNavState) {
      base.fromTroubleFromLearnings = returnNavState.fromTroubleFromLearnings;
      base.fromTroubleFromSubtopic = returnNavState.fromTroubleFromSubtopic;
      base.returnToSubtopicState = returnNavState.returnToSubtopicState;
    }
    return base;
  };

  const handlePopupYes = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    const ctx = selectedPracticeContext;
    if (!ctx) {
      setShowPopup(false);
      return;
    }
    navigate("/practice", {
      state: getPracticeState(ctx, hasActiveSession),
    });
    setShowPopup(false);
  };

  const handlePopupNo = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    const ctx = selectedPracticeContext;
    if (hasActiveSession && ctx) {
      navigate("/practice", {
        state: getPracticeState(ctx, false),
      });
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
  };

  const toggleModule = (id) => {
    const set = new Set(expandedModules);
    set.has(id) ? set.delete(id) : set.add(id);
    setExpandedModules(set);
  };

  const toggleTopic = (id) => {
    const set = new Set(expandedTopics);
    set.has(id) ? set.delete(id) : set.add(id);
    setExpandedTopics(set);
  };

  const formatTime = (seconds = 0) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "-";

  return (
    <div className={style.Container}>
      <div className={style.subContainer}>
        <div className={style.headerWrapper}>
          <div className={style.leftHeader}>
            <div className={style.leftHeaderTop}>
              <img src={troubleIcon} alt="" />
              <p>Trouble Spots</p>
            </div>
            <div className={style.leftHeaderdown}>
              <p>Let’s focus on the skills that need improvement</p>
            </div>
          </div>
          <img src={setting} alt="" />
        </div>

        {loading && <div className={style.moduleCard} aria-hidden="true" />}

        {!loading && data.length === 0 && (
          <div className={style.moduleCard}>
            <div className={style.leftContainer}>
              <p>No trouble spots found</p>
              <span>You’re doing great — keep practicing!</span>
            </div>
          </div>
        )}

        {!loading &&
          data.map((module) => (
          <div key={module.module_id} className={style.moduleCard}>
            <div
              className={style.moduleConatiner}
              onClick={() => toggleModule(module.module_id)}
            >
              <p className={style.moduleCardName}>Module {module.module_number} : {module.module_name}</p>
              <img
                src={
                  expandedModules.has(module.module_id)
                    ? uparrow
                    : downarrow
                }
                alt=""
              />
            </div>

            {expandedModules.has(module.module_id) && (
              <div className={style.topicContainer}>
                {module.topics?.map((topic) => (
                  <div key={topic.topic_id}>
                    <div
                      className={style.topicCard}
                      onClick={() => toggleTopic(topic.topic_id)}
                    >
                      <p>{topic.topic_name}</p>
                      <img
                        src={
                          expandedTopics.has(topic.topic_id)
                            ? uparrow
                            : downarrow
                        }
                        alt=""
                      />
                    </div>

                    {expandedTopics.has(topic.topic_id) &&
                      topic.sub_topics?.map((sub) =>
                        sub.skills?.map((skill) => {
                          const total = skill.total_mark || 50;
                          const scored = skill.mark_scored || 0;
                          const step = total / 5;
                          const filled = Math.min(
                            5,
                            Math.ceil(scored / step)
                          );
                          const percent = Math.max(0,(scored / total) * 100);

                          return (
                            <div
                              key={skill.skill_id}
                              className={style.skillCard}
                            >
                              <div className={style.skillLeft}>
                                <p className={style.skillName}>
                                  <span>{sub.sub_topic_name}&nbsp;&gt;&nbsp;</span>{skill.skill_name}
                                </p>
                              </div>

                              <div className={style.skillRight}>

                                <div className={style.skillMetaRow}>
                                  <div className={style.practiceLevel}>
                                    <p>Practice Level</p>
                                    <div className={style.rangeContainer}>
                                      {[...Array(5)].map((_, i) => (
                                        <img
                                          key={i}
                                          src={i < filled ? range : emptyrange}
                                          alt=""
                                        />
                                      ))}
                                    </div>
                                  </div>
                                  <div className={style.timeVessel}>
                                    <div>
                                      <p>Time Spent</p>
                                      <span>{formatTime(skill.total_time_spend)}</span>
                                    </div>
                                    <div>
                                      <p>Last Practiced</p>
                                      <span>{formatDate(skill.last_attended)}</span>
                                    </div>
                                    <div className={style.proficiencyContainer}>
                                      <p>Proficiency</p>
                                      <span>{percent}%</span>
                                    </div>
                                  </div>

                                  <button
                                    className={style.againWrapper}
                                    onClick={async () => {
                                      const aiId = await fetchAiId(topic.topic_id);
                                      if (!aiId) {
                                        alert("AI not initialized for this topic.");
                                        return;
                                      }
                                      const ctx = {
                                        ai_id: aiId,
                                        main_topic_id: module.module_id,
                                        topic_id: topic.topic_id,
                                        topic_name: topic.topic_name,
                                        subtopic_title: sub.sub_topic_name,
                                        skill_id: skill.skill_id,
                                        skill_name: skill.skill_name,
                                      };
                                      const assessment = await checkActiveSession(ctx);
                                      setSelectedPracticeContext(ctx);
                                      setLastAssessmentData(assessment);
                                      const isFromLearnings = location.pathname === "/new/learnings";
                                      const isFromSubtopic = location.pathname === "/subtopic";
                                      setReturnNavState({
                                        fromTroubleFromLearnings: isFromLearnings,
                                        fromTroubleFromSubtopic: isFromSubtopic,
                                        returnToSubtopicState: isFromSubtopic ? location.state : undefined,
                                      });
                                      const hasSession = Boolean(assessment?.session_status);
                                      setPopupText(
                                        hasSession
                                          ? "Do you want to continue with your paused assessment?"
                                          : "Are you sure you want to start a practice session?"
                                      );
                                      setShowPopup(true);
                                    }}
                                  >
                                    Practice Again
                                  </button>
                                </div>

                              </div>

                            </div>
                          );
                        })
                      )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {showPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            {hasActiveSession && (
              <button
                type="button"
                className={style.popupCloseButton}
                onClick={handlePopupClose}
                aria-label="Close"
              >
                <IoClose />
              </button>
            )}
            <div className={style.popupText}>
              <p>{popupText}</p>
              {hasActiveSession && (
                <span>You paused on the practice test sub-topic</span>
              )}
            </div>
            <div className={style.PopupButton}>
              <button className={style.noButton} onClick={handlePopupNo}>
                {hasActiveSession ? "No, start again please" : "No"}
              </button>
              <button className={style.yesButton} onClick={handlePopupYes}>
                {hasActiveSession ? "Yes" : "Yes"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Trouble;
